import React from 'react'
import type { IProductSortOrder } from '@/schemas/catalog/productFilters'

interface IOrderButtonsProps {
    order: IProductSortOrder | null
    onChange: (order: IProductSortOrder) => void
}

const buttonClass = (active: boolean) =>
    `border border-secondary text-secondary rounded-full h-8 w-8 p-1 text-sm font-semibold font-sora hover:bg-secondary hover:text-white ${active ? 'bg-secondary text-white' : ''}`

/** Ordenação por preço do filtro da listagem: "$" menor preço primeiro, "$$" maior. */
const OrderButtons: React.FC<IOrderButtonsProps> = ({ order, onChange }) => (
    <div className="flex gap-2">
        <button
            type="button"
            aria-label="Menor preço primeiro"
            onClick={() => onChange('asc')}
            className={buttonClass(order === 'asc')}
        >
            $
        </button>

        <button
            type="button"
            aria-label="Maior preço primeiro"
            onClick={() => onChange('desc')}
            className={buttonClass(order === 'desc')}
        >
            $$
        </button>
    </div>
)

export default OrderButtons
